import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeHelper } from '../helpers/datetime.helper';

@Pipe({
  name: 'timeFormat',
  standalone: true
})
export class TimeFormatPipe implements PipeTransform {
  constructor() { }

  transform(value: Date, ..._: unknown[]): string {
    return DateTimeHelper.formatTime(value);
  }
}
